import React, { useState } from "react";
import AuthContainer from "./AuthContainer";
import { Button, Form, Input, message } from "antd";
import { emailPattern, FormItemRequiredRule } from "Utility/Constants";
import { Auth } from "aws-amplify";
import { Link, useNavigate } from "react-router-dom";

export const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [isLoading, setisLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotLink = async (data) => {
    const userEmail = data?.email;
    try {
      setisLoading(true);
      await Auth.forgotPassword(userEmail);
      message.success("Mail has been sent to your mail");
      navigate("/reset-password", {
        state: {
          email: userEmail,
        },
      });
    } catch (err) {
      console.log(err?.message, "forgot password error");
      if (err?.message === "Username/client id combination not found.") {
        message.error(
          "This email is not registered. Please check and try again."
        );
      } else {
        message.error(err?.message);
      }
    } finally {
      setisLoading(false);
    }
  };

  return (
    <AuthContainer type={"forgot-password"}>
      <Form
        onFinish={handleForgotLink}
        layout="vertical"
        requiredMark={false}
        form={form}
        name="forgot-password"
        initialValues={{ remember: true }}
        className="space-y-6 login-register-form"
      >
        <Form.Item
          name={"email"}
          rules={[
            FormItemRequiredRule,
            { pattern: emailPattern, message: "Please enter proper email" },
          ]}
        >
          <Input
            placeholder="Email"
            className={"p-2 rounded-md input-border"}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="w-full rounded-lg"
            loading={isLoading}
          >
            Send link
          </Button>
        </Form.Item>
        <div className="text-center">
          <Link
            to="/register"
            className="text-sm hover:underline hover:text-black"
          >
            Create new account?
          </Link>
        </div>
      </Form>
    </AuthContainer>
  );
};
